export var TransferOrderType;
(function (TransferOrderType) {
    TransferOrderType[TransferOrderType["STANDARD"] = 1] = "STANDARD";
    TransferOrderType[TransferOrderType["RETURN"] = 2] = "RETURN";
})(TransferOrderType || (TransferOrderType = {}));
//# sourceMappingURL=transfer-order-type.js.map